import { SafetyQualityApi } from '@wiz-api/haiguang'
import { instance as cloudRender } from 'wiz-cloud-render'
import { findIndex, filter, find, map } from 'lodash'

const safetyQualityApi = new SafetyQualityApi()
const tenantId =
  localStorage.getItem('CurrentTenantId') ||
  JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId ||
  '8b53295c-b059-4caf-8fc6-4a1d9e7807e9'

let problemList = []
let markerList = []
const getProblemList = async () => {
  const [err, res] = await safetyQualityApi.getSafetyQualityVisualProblemList({
    body: {
      maxResultCount: 999,
      skipCount: 0,
      projectId: tenantId,
      Type: '',
      FlowStatus: '',
    },
  })
  if (!err) {
    problemList = res.items
  }
}
const calcPosition = async (code, problemId) => {
  const modelRes = await cloudRender.NodeProxy.getInfo('Code', code)
  if (modelRes && modelRes.status && modelRes.data) {
    const itemAabb = await cloudRender.NodeProxy.getAabb(modelRes.data)
    if (itemAabb.status && itemAabb.data?.aabb?.length) {
      const sameCodeList = filter(problemList, ['kksCode', code])
      const index = findIndex(sameCodeList, ['problemId', problemId])
      console.log(itemAabb.data.aabb, 55555)
      let xPoint = 0
      if (sameCodeList.length > 1) {
        const step =
          (itemAabb.data.aabb[1][0] - itemAabb.data.aabb[0][0]) / (sameCodeList.length - 1)
        xPoint = itemAabb.data.aabb[0][0] + step * index
      } else {
        xPoint =
          itemAabb.data.aabb[0][0] + (itemAabb.data.aabb[1][0] - itemAabb.data.aabb[0][0]) / 2
      }
      return [
        xPoint,
        itemAabb.data.aabb[0][1] + (itemAabb.data.aabb[1][1] - itemAabb.data.aabb[0][1]) / 2,
        itemAabb.data.aabb[1][2],
      ]
    }
    return [0, 0, 0]
  }
  return [0, 0, 0]
}
const markerClick = (e) => {
  console.log(e, 22222)
  // 左键点击并且有id
  if (e.type === 1 && e.markerId) {
    const clickInfo = find(markerList, (item) => {
      return item.markerId === e.markerId
    })
    if (clickInfo) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'SafetyQualityDetail',
            origin: 'tag',
            name: '质量安全问题详情',
            originTagName: 'SafetyQuality',
          },
          type: 'tags',
          props: {
            problemId: clickInfo.problemId,
          },
        },
      })
      window.dispatchEvent(openEvent)
    }
  }
}
const create = async () => {
  cloudRender.Dispatch.on('Marker', markerClick)
  await getProblemList()
  const imageEnum = {
    整改中: 'rectification',
    验收中: 'acceptance',
    已完成: 'done',
  }

  for (let i = 0; i < problemList.length; i += 1) {
    const item = problemList[i]
    // eslint-disable-next-line no-await-in-loop
    const pos = await calcPosition(item.kksCode, item.problemId)
    console.log(pos, 1222222222222222)
    const backgroundUrl = `data://../apps/markers/safetyQuality/${imageEnum[item.flowStatus]}.png`
    const pictureOption = {
      id: item.problemId,
      pos,
      backgroundUrl,
      visible: true,
      nodeOffset: [0, 0],
      imgSize: [61, 88],
      markPosType: 4,
    }
    // eslint-disable-next-line no-await-in-loop
    const picRes = await cloudRender.Marker.createByPicture(pictureOption)
    if (picRes.status && picRes.data?.length) {
      markerList.push({
        markerId: picRes.data[0],
        ...item,
      })
    }
  }
  console.log(markerList, 1111111)
}
const destroy = async () => {
  // 销毁图标
  await cloudRender.Marker.destroyMarker(map(markerList, 'markerId'))
  markerList = []
  // 取消标签的事件监听
  cloudRender.Dispatch.off('Marker', markerClick)
}
// 隐藏标签
const hidden = async () => {
  await cloudRender.Marker.updateByPicture(
    map(markerList, (item) => {
      return {
        id: item.markerId,
        visible: false,
      }
    })
  )
}

// 重新显示标签
const display = async () => {
  await cloudRender.Marker.updateByPicture(
    map(markerList, (item) => {
      return {
        id: item.markerId,
        visible: true,
      }
    })
  )
}
// 根据条件显示图标
const filterDisplay = async (params) => {
  if (markerList.length) {
    if (params.type || params.flowStatus) {
      const displayList = filter(markerList, (item) => {
        if (params.type && params.flowStatus) {
          return item.type === params.type && item.flowStatus === params.flowStatus
        }
        if (params.type) {
          return item.type === params.type
        }
        if (params.flowStatus) {
          return item.flowStatus === params.flowStatus
        }
        return true
      })
      await hidden()
      await cloudRender.Marker.updateByPicture(
        map(displayList, (item) => {
          return {
            id: item.markerId,
            visible: true,
          }
        })
      )
    } else {
      display()
    }
  }
}
export default { create, destroy, hidden, display, filterDisplay }
